/**
 * Fetch wrapper with auth headers and error handling.
 */

function getToken(): string | null {
  return localStorage.getItem('wa_access_token');
}

export async function apiFetch<T>(
  url: string,
  options: RequestInit = {},
): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = {
    ...(options.headers as Record<string, string> || {}),
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (options.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401 || response.status === 403) {
    if (import.meta.env.VITE_AUTH_DISABLED !== 'true' && token) {
      localStorage.removeItem('wa_access_token');
      window.location.href = '/login';
    }
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Unauthorized');
  }

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `HTTP ${response.status}`);
  }

  if (response.headers.get('Content-Type')?.includes('application/json')) {
    return response.json();
  }
  return response as unknown as T;
}
